export default __webpack_public_path__ + "static/media/Q.d673ac47.svg";